/**
 * Modal Component for FlowRide Frontend
 * Reusable modal component with backdrop and close functionality.
 * Provides a centered overlay for displaying content with proper event handling.
 */

import React from "react";
import CloseSVG from "../../image/icons/calendar/Close.svg";
import { getUIColorPalette } from "../../theme/ColorPalette";

interface ModalProps {

    /** Child components to render inside the modal */
    "children": React.ReactNode;

    /** Whether the modal is open */
    "isOpen": boolean;

    /** Function to close the modal */
    "onClose":   ( value: boolean ) => void;
    "isDarkUi"?: boolean;

    /** Whether the top-right close icon is shown. Defaults to `true`. */
    "showCloseButton"?: boolean;
}

const Modal: React.FC<ModalProps> = ( { children, isOpen, onClose, isDarkUi = false, showCloseButton = true } ) => {
    if ( !isOpen ) {
        return null;
    }
    const palette = getUIColorPalette( isDarkUi );

    return (
        <div
            className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50"
            onClick={() => {
                onClose( false );
            }}
            style={{ "backgroundColor": palette.modalBackdropBackground }}
        >
            <div
                className="rounded-xl p-6 relative w-4/5 lg:w-2/6 border"
                onClick={( e ) => {
                    e.stopPropagation();
                }} // Prevent clicks from bubbling up
                style={{
                    "backgroundColor": palette.modalCardBackground,
                    "borderColor":     palette.modalCardBorder,
                    "color":           palette.modalCardTextPrimary,
                }}
            >
                {showCloseButton && (
                    <button
                        className="absolute top-3 right-3"
                        onClick={() => {
                            onClose( false );
                        }}
                    >
                        <img
                            alt="Close"
                            src={CloseSVG}
                        />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};

export default Modal;
